import {
  getSubscriptionIntegrationTypeApi,
  getStripeSubscriptionInformationApi,
  getStripeSessionClientSecretApi,
  getBillingPortalLinkApi,
} from './api';

import type {
  StripeBillingPortalLinkResponse,
  StripeCustomerSecretResponse,
  SubscriptionIntegrationType,
  StripeSession,
} from '../../entities';

export function getSubscriptionIntegrationType(): Promise<SubscriptionIntegrationType> {
  return getSubscriptionIntegrationTypeApi().toPromise();
}

export function getStripeSubscriptionInformation(): Promise<StripeSession> {
  return getStripeSubscriptionInformationApi().toPromise();
}

export function getStripeSessionClientSecret(): Promise<StripeCustomerSecretResponse> {
  return getStripeSessionClientSecretApi().toPromise();
}

export function getBillingPortalLink(
  callbackUrl: string
): Promise<StripeBillingPortalLinkResponse> {
  return getBillingPortalLinkApi({
    return_url: callbackUrl,
  }).toPromise();
}
